


const data_management = [

    { name: "Châu Hoài Vũ", Plates: 7894561230, ID: 123456789, Phone: "1234567891011", Location: "102"},
    { name: "Nguyễn Đức Nam",  Plates: 7845621590, ID: 123456789, Phone: "1234567891011", Location: "305" },
    { name: "Trân Triệu Tuân",  Plates: 741852912, ID: 123456789, Phone: "1234567891011", Location: "402" },
    { name: "Lê Quan Thái",  Plates: 9876543210, ID: 123456789, Phone: "1234567891011", Location: "104" },
    { name: "Ktuyt's", Plates: 7845621301, ID: 123456789, Phone: "1234567891011", Location: "202" },
    { name: "Đao Văn Ngọc Hoàng",  Plates: 7845621590, ID: 123456789, Phone: "1234567891011", Location: "505" },
    { name: "Hà Đức Tuấn",  Plates: 741852912, ID: 123456789, Phone: "1234567891011", Location: "506" },
    { name: "Ngô Văn kiều",  Plates: 9876543210, ID: 123456789, Phone: "1234567891011", Location: "303" },
    { name: "Trần Thanh Thoa",  Plates: 7894561230, ID: 123456789, Phone: "1234567891011", Location: "107"},
    { name: "Nguyện Thị Ngọc", Plates: 7845621590, ID: 123456789, Phone: "1234567891011", Location: "207" },
    { name: "Bảo Gia Hân",  Plates: 741852912, ID:123456789 , Phone: "1234567891011", Location: "310" },
    { name: "Trịnh Quốc PHúc",  Plates: 9876543210, ID: 123456789, Phone: "1234567891011", Location: "410" },
  
  
  ]
  
  
  export default data_management
  
  
  